<template>
  <div class="bg-surface rounded-lg p-5 max-w-[58rem] mx-auto mt-6 space-y-7">
    <img
      :src="props.scormCourse.previewImageUrl"
      :alt="t('content.scorm-course-preview-alt')"
      class="w-full object-cover rounded-md aspect-16/9"
    />

    <div
      v-if="props.scormCourse.description"
      class="prose max-w-full"
      v-html="props.scormCourse.description"
    />

    <div class="text-center pb-3">
      <Button :label="t('content.launch-course')" @click="onLaunchCourse()" />
      <ScormPlayerModal
        v-if="courseUrl"
        :title="props.content.title"
        :course-url="courseUrl"
        @close="onScormModalClose"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@exfluential/ui';
import { ScormPlayerModal } from '~/components/scorm-player-modal';
import { apiInviteToScorm, ContentDto } from '~/api/contents';
import { HubDto } from '~/api/hubs';

type Props = {
  hub: HubDto;
  content: ContentDto;
  scormCourse: NonNullable<ContentDto['scormCourse']>;
};
const props = defineProps<Props>();

const emit = defineEmits<{
  refresh: [];
}>();

const { t } = useI18n();

let refreshInterval: ReturnType<typeof setTimeout>;

const courseUrl = ref<null | string>(null);

const onLaunchCourse = async () => {
  clearInterval(refreshInterval);

  await useLoader({
    async action() {
      const res = await apiInviteToScorm(props.hub.id, props.content.id);

      courseUrl.value = res.launchUrl;
    },
    onError(err) {
      throw err;
    },
  });
};

const onScormModalClose = () => {
  courseUrl.value = null;

  if (props.hub.isLaunchEnabled && !props.content.launchData?.completedAt) {
    refreshInterval = setInterval(() => {
      emit('refresh');
    }, 1000);
  }
};

watch(
  () => props.content,
  () => {
    if (props.content.launchData?.completedAt) {
      clearInterval(refreshInterval);
    }
  },
);

onUnmounted(() => {
  clearInterval(refreshInterval);
});
</script>
